import {
    GROUP_JOBTITLE_DATA,    
    GROUP_JOBTITLE_GET_DATA, 
    //Ticketing APIs
    GROUPBYTYPE_ADMIN_GET_DATA,
    GROUPBYTYPE_USER_GET_DATA,
    GROUPBY_ID_JOBTITLE_GET_DATA
  } from "./Constants";
  
  //For listing
  const loadGroupJobTitlesDataRequest = () => ({
    type: GROUP_JOBTITLE_DATA.GROUP_JOBTITLE_DATA_LOAD,
  });
  const setGroupJobTitlesDataSuccess = (groupjobtitles) => ({
    type: GROUP_JOBTITLE_DATA.GROUP_JOBTITLE_DATA_SUCCESS,
    groupjobtitles,
  });
  const setGroupJobTitlesDataFail = (error) => ({
    type: GROUP_JOBTITLE_DATA.GROUP_JOBTITLE_DATA_FAIL,
    error,
  });
  
  
  
  //To Get
  const loadGroupJobTitlesGetDataRequest = (id) => ({
    type: GROUP_JOBTITLE_GET_DATA.GROUP_JOBTITLE_GET_DATA_LOAD,
    id,
  });
  
  const setGroupJobTitlesGetDataSuccess = (groupjobtitle) => ({
    type: GROUP_JOBTITLE_GET_DATA.GROUP_JOBTITLE_GET_DATA_SUCCESS,
    groupjobtitle,
  });
  
  const setGroupJobTitlesGetDataFail = (error) => ({
    type: GROUP_JOBTITLE_GET_DATA.GROUP_JOBTITLE_GET_DATA_FAIL,
    error,
  });

  // Ticketing APIs

  //To Get group by Type admin for ticketing
  const loadGroupByTypeAdminGetDataRequest = (role) => ({
    type: GROUPBYTYPE_ADMIN_GET_DATA.GROUPBYTYPE_ADMIN_GET_DATA_LOAD,
    role,
  });
  
  const setGroupByTypeAdminGetDataSuccess = (adminGroup) => ({
    type: GROUPBYTYPE_ADMIN_GET_DATA.GROUPBYTYPE_ADMIN_GET_DATA_SUCCESS,
    adminGroup,
  });
  
  const setGroupByTypeAdminGetDataFail = (error) => ({
    type: GROUPBYTYPE_ADMIN_GET_DATA.GROUPBYTYPE_ADMIN_GET_DATA_FAIL,
    error,
  });

  //To Get group by Type user for ticketing
  const loadGroupByTypeUserGetDataRequest = (role, filter = null) => ({
    type: GROUPBYTYPE_USER_GET_DATA.GROUPBYTYPE_USER_GET_DATA_LOAD,
    role,
    filter,
  });
  
  const setGroupByTypeUserGetDataSuccess = (userGroup) => ({
    type: GROUPBYTYPE_USER_GET_DATA.GROUPBYTYPE_USER_GET_DATA_SUCCESS,
    userGroup,
  });
  
  const setGroupByTypeUserGetDataFail = (error) => ({
    type: GROUPBYTYPE_USER_GET_DATA.GROUPBYTYPE_USER_GET_DATA_FAIL,
    error,
  });

  //To Get jobtitle by id for ticketing
  const loadGroupByIDJobTitlesGetDataRequest = (id) => ({
    type: GROUPBY_ID_JOBTITLE_GET_DATA.GROUPBY_ID_JOBTITLE_GET_DATA_LOAD,
    id,
  });
  
  const setGroupByIDJobTitlesGetDataSuccess = (group) => ({
    type: GROUPBY_ID_JOBTITLE_GET_DATA.GROUPBY_ID_JOBTITLE_GET_DATA_SUCCESS,
    group,
  });
  
  const setGroupByIDJobTitlesGetDataFail = (error) => ({
    type: GROUPBY_ID_JOBTITLE_GET_DATA.GROUPBY_ID_JOBTITLE_GET_DATA_FAIL,
    error,
  });
  
  
  export {
    loadGroupJobTitlesDataRequest,
    setGroupJobTitlesDataSuccess,
    setGroupJobTitlesDataFail,
    loadGroupJobTitlesGetDataRequest,
    setGroupJobTitlesGetDataSuccess,
    setGroupJobTitlesGetDataFail,
    loadGroupByTypeAdminGetDataRequest,
    setGroupByTypeAdminGetDataSuccess,
    setGroupByTypeAdminGetDataFail,
    loadGroupByTypeUserGetDataRequest,
    setGroupByTypeUserGetDataSuccess,
    setGroupByTypeUserGetDataFail,
    loadGroupByIDJobTitlesGetDataRequest,
    setGroupByIDJobTitlesGetDataSuccess,
    setGroupByIDJobTitlesGetDataFail,
  };
  